import { B2B_AVAILABLE_PRODUCTS } from '@src/global/utils/config';
import { PHYSICAL_QTY_MAX_FOR_B2C } from '@src/global/App/constants/constants';
import { OrderItemType } from '@src/global/utils/AdobeAnalytics/types';

export const isB2BAvailableProduct = (orderItems: OrderItemType[]): boolean => {
  const isBulkOrder = orderItems.some(
    (item) =>
      B2B_AVAILABLE_PRODUCTS.includes(item.isbn13) &&
      item.qty > PHYSICAL_QTY_MAX_FOR_B2C
  );
  return isBulkOrder;
};
